import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable()
export class Utilities {

    constructor() {}

    public colors: Array<string> = ["#7F6400", "#FFD94D", "#FFC801", "#7F6C27", "#FFC801", "#7F7F7F", "#FFB2B2", "#FFFFFF", "#7F5959", "#666666"];

    getTimes() {
        var times = [];
        var hours, minutes, ampm;
        for (var i = 0; i <= 1380; i += 60) {
            hours = Math.floor(i / 60);
            minutes = i % 60;
            if (minutes < 10) {
                minutes = '0' + minutes; // adding leading zero
            }
            ampm = hours % 24 < 12 ? 'AM' : 'PM';
            hours = hours % 12;
            if (hours === 0) {
                hours = 12;
            }
            times.push(hours + ':' + minutes + ' ' + ampm);
        }
        return times;
    }

    getTimeZones() {
        return moment.tz.names();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/Common/utilities.service.ts